import { render, staticRenderFns } from "./realTime.vue?vue&type=template&id=e2e486ae&scoped=true&"
import script from "./realTime.vue?vue&type=script&lang=js&"
export * from "./realTime.vue?vue&type=script&lang=js&"
import style0 from "./realTime.vue?vue&type=style&index=0&id=e2e486ae&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2e486ae",
  null
  
)

export default component.exports